import { createFileRoute } from "@tanstack/react-router";

import { AgentsListPage } from "@/routes/app/speech-agent/agents";

export const Route = createFileRoute(
  "/app/speech-agent/agents/"
)({
  component: AgentsListPage,
});
